(() => {
  if (window.AACUnitSearch) return;

  const unitGroups = [
    {
      "aliases": [
        "101ABN",
        "101st Airborne Division",
        "101 Airborne",
        "101st Airborne",
        "101 ABN",
        "101st ABN"
      ],
      "label": "101st Airborne Division",
      "tag": "AAC_UNIT_101ABN"
    },
    {
      "aliases": [
        "10SFG",
        "10th Special Forces Group (Airborne)",
        "10 SFG",
        "10th SFG",
        "10 Special Forces"
      ],
      "label": "10th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_10SFG"
    },
    {
      "aliases": [
        "118MP",
        "118th Military Police Company"
      ],
      "label": "118th Military Police Company",
      "tag": "AAC_UNIT_118MP"
    },
    {
      "aliases": [
        "11ABN",
        "11th Airborne Division",
        "11 Airborne",
        "11th Airborne",
        "11 ABN",
        "11th ABN"
      ],
      "label": "11th Airborne Division",
      "tag": "AAC_UNIT_11ABN"
    },
    {
      "aliases": [
        "011SFG",
        "11th Special Forces Group (Airborne)",
        "11 SFG",
        "11th SFG",
        "11 Special Forces"
      ],
      "label": "11th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_011SFG"
    },
    {
      "aliases": [
        "122ASB",
        "122nd Aviation Support Battalion"
      ],
      "label": "122nd Aviation Support Battalion",
      "tag": "AAC_UNIT_122ASB"
    },
    {
      "aliases": [
        "127ENG",
        "127th Engineer Battalion"
      ],
      "label": "127th Engineer Battalion",
      "tag": "AAC_UNIT_127ENG"
    },
    {
      "aliases": [
        "12POB",
        "12th Psychological Operations Battalion",
        "12th PSYOP Battalion",
        "12th POB"
      ],
      "label": "12th Psychological Operations Battalion",
      "tag": "AAC_UNIT_12POB"
    },
    {
      "aliases": [
        "12SFG",
        "12th Special Forces Group (Airborne)",
        "12 SFG",
        "12th SFG",
        "12 Special Forces"
      ],
      "label": "12th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_12SFG"
    },
    {
      "aliases": [
        "1436ENG",
        "1436th Engineer Company"
      ],
      "label": "1436th Engineer Company",
      "tag": "AAC_UNIT_1436ENG"
    },
    {
      "aliases": [
        "160SOAR",
        "160th Special Operations Aviation Regiment (Airborne)",
        "160 Special Operations Aviation",
        "160th Special Operations Aviation"
      ],
      "label": "160th Special Operations Aviation Regiment (Airborne)",
      "tag": "AAC_UNIT_160SOAR"
    },
    {
      "aliases": [
        "16MPBDE",
        "16th Military Police Brigade"
      ],
      "label": "16th Military Police Brigade",
      "tag": "AAC_UNIT_16MPBDE"
    },
    {
      "aliases": [
        "173ABN",
        "173rd Airborne Brigade",
        "173rd ABN BDE",
        "173rd Airborne",
        "173rd ABN",
        "Sky Soldiers",
        "173 Airborne",
        "173 ABN",
        "Electronic Warfare Platoon, 173rd Military Intelligence Company"
      ],
      "label": "173rd Airborne Brigade",
      "tag": "AAC_UNIT_173ABN"
    },
    {
      "aliases": [
        "173LSB",
        "173rd Light Support Battalion (Airborne)",
        "173rd LSB (A)",
        "173rd Light Support Battalion",
        "173rd LSB",
        "173 LSB"
      ],
      "label": "173rd Light Support Battalion (Airborne)",
      "tag": "AAC_UNIT_173LSB"
    },
    {
      "aliases": [
        "173MICO",
        "173rd Military Intelligence Company",
        "173rd MICO",
        "173 MICO",
        "173rd ABN MICO"
      ],
      "label": "173rd Military Intelligence Company",
      "tag": "AAC_UNIT_173MICO"
    },
    {
      "aliases": [
        "187INF",
        "187th Infantry Regiment",
        "187 Infantry",
        "187th Infantry",
        "187 Airborne",
        "187 AIR",
        "187 PIR"
      ],
      "label": "187th Infantry Regiment",
      "tag": "AAC_UNIT_187INF"
    },
    {
      "aliases": [
        "189SB",
        "189th Support Battalion"
      ],
      "label": "189th Support Battalion",
      "tag": "AAC_UNIT_189SB"
    },
    {
      "aliases": [
        "18AFAB",
        "18th Field Artillery Brigade"
      ],
      "label": "18th Field Artillery Brigade",
      "tag": "AAC_UNIT_18AFAB"
    },
    {
      "aliases": [
        "193INF",
        "193rd Infantry Brigade"
      ],
      "label": "193rd Infantry Brigade",
      "tag": "AAC_UNIT_193INF"
    },
    {
      "aliases": [
        "19SFG",
        "19th Special Forces Group (Airborne)",
        "19 SFG",
        "19th SFG",
        "19 Special Forces"
      ],
      "label": "19th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_19SFG"
    },
    {
      "aliases": [
        "1ANGLICO",
        "1st Air Naval Gunfire Liaison Company"
      ],
      "label": "1st Air Naval Gunfire Liaison Company",
      "tag": "AAC_UNIT_1ANGLICO"
    },
    {
      "aliases": [
        "110SFG",
        "1st Battalion, 10th Special Forces Group (Airborne)",
        "1-10",
        "1/10",
        "110",
        "1st battalion 10",
        "1st BN 10"
      ],
      "label": "1st Battalion, 10th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_110SFG"
    },
    {
      "aliases": [
        "111SFG",
        "1st Battalion, 11th Special Forces Group (Airborne)",
        "1/11 SFG",
        "1-11th Special Forces Group",
        "1-11",
        "1/11",
        "111",
        "1st battalion 11",
        "1st BN 11"
      ],
      "label": "1st Battalion, 11th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_111SFG"
    },
    {
      "aliases": [
        "112SFG",
        "1st Battalion, 12th Special Forces Group (Airborne)",
        "1/12 SFG",
        "1-12th Special Forces Group",
        "1-12",
        "1/12",
        "112",
        "1st battalion 12",
        "1st BN 12"
      ],
      "label": "1st Battalion, 12th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_112SFG"
    },
    {
      "aliases": [
        "1187INF",
        "1st Battalion, 187th Infantry Regiment",
        "1-187",
        "1/187",
        "1187",
        "1st battalion 187",
        "1st BN 187",
        "1-187 AIR",
        "1-187 PIR",
        "1/187 AIR"
      ],
      "label": "1st Battalion, 187th Infantry Regiment",
      "tag": "AAC_UNIT_1187INF"
    },
    {
      "aliases": [
        "119SFG",
        "1st Battalion, 19th Special Forces Group (Airborne)",
        "1-19",
        "1/19",
        "119",
        "1st battalion 19",
        "1st BN 19"
      ],
      "label": "1st Battalion, 19th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_119SFG"
    },
    {
      "aliases": [
        "11SFG",
        "1st Battalion, 1st Special Forces Group (Airborne)",
        "1-1",
        "1/1",
        "11",
        "1st battalion 1",
        "1st BN 1"
      ],
      "label": "1st Battalion, 1st Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_11SFG"
    },
    {
      "aliases": [
        "120SFG",
        "1st Battalion, 20th Special Forces Group (Airborne)",
        "1-20",
        "1/20",
        "120",
        "1st battalion 20",
        "1st BN 20"
      ],
      "label": "1st Battalion, 20th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_120SFG"
    },
    {
      "aliases": [
        "28INF",
        "1st Battalion, 28th Infantry Regiment",
        "1-28",
        "1/28",
        "128",
        "1st battalion 28",
        "1st BN 28",
        "1-28 AIR",
        "1-28 PIR",
        "1/28 AIR"
      ],
      "label": "1st Battalion, 28th Infantry Regiment",
      "tag": "AAC_UNIT_28INF"
    },
    {
      "aliases": [
        "1319FAR",
        "1-319",
        "1/319",
        "1st Battalion, 319th AFAR",
        "1-319 AFAR",
        "1st BN 319"
      ],
      "label": "1st Battalion, 319th Airborne Field Artillery Regiment",
      "tag": "AAC_UNIT_1319FAR"
    },
    {
      "aliases": [
        "1320FA",
        "1st Battalion, 320th Field Artillery Regiment",
        "1-320",
        "1/320",
        "1320",
        "1st battalion 320",
        "1st BN 320"
      ],
      "label": "1st Battalion, 320th Field Artillery Regiment",
      "tag": "AAC_UNIT_1320FA"
    },
    {
      "aliases": [
        "1321FAR",
        "1st Battalion, 321st Field Artillery Regiment",
        "1-321",
        "1/321",
        "1321",
        "1st battalion 321",
        "1st BN 321"
      ],
      "label": "1st Battalion, 321st Field Artillery Regiment",
      "tag": "AAC_UNIT_1321FAR"
    },
    {
      "aliases": [
        "1325INF",
        "1st Battalion, 325th Airborne Infantry Regiment",
        "1/325 AIR",
        "1-325",
        "1/325",
        "1st BN 325 AIR",
        "1-325AIR",
        "Red Falcons",
        "1325",
        "1st battalion 325",
        "1st BN 325",
        "1-325 AIR",
        "1-325 PIR"
      ],
      "label": "1st Battalion, 325th Airborne Infantry Regiment",
      "tag": "AAC_UNIT_1325INF"
    },
    {
      "aliases": [
        "1327INF",
        "1st Battalion, 327th Infantry Regiment",
        "1-327",
        "1/327",
        "1327",
        "1st battalion 327",
        "1st BN 327",
        "1-327 AIR",
        "1-327 PIR",
        "1/327 AIR"
      ],
      "label": "1st Battalion, 327th Infantry Regiment",
      "tag": "AAC_UNIT_1327INF"
    },
    {
      "aliases": [
        "1377FAR-C",
        "1st Battalion, 377th Airborne Field Artillery Regiment",
        "1-377",
        "1/377",
        "1377",
        "1st battalion 377",
        "1st BN 377",
        "1-377 AIR",
        "1-377 PIR",
        "1/377 AIR"
      ],
      "label": "1st Battalion, 377th Airborne Field Artillery Regiment",
      "tag": "AAC_UNIT_1377FAR-C"
    },
    {
      "aliases": [
        "13SFG",
        "1st Battalion, 3rd Special Forces Group (Airborne)",
        "1-3",
        "1/3",
        "13",
        "1st battalion 3",
        "1st BN 3"
      ],
      "label": "1st Battalion, 3rd Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_13SFG"
    },
    {
      "aliases": [
        "1501INF",
        "1st Battalion, 501st Infantry Regiment",
        "1-501",
        "1/501",
        "1501",
        "1st battalion 501",
        "1st BN 501",
        "1-501 AIR",
        "1-501 PIR",
        "1/501 AIR"
      ],
      "label": "1st Battalion, 501st Infantry Regiment",
      "tag": "AAC_UNIT_1501INF"
    },
    {
      "aliases": [
        "1502INF",
        "1st Battalion, 502nd Infantry Regiment",
        "1-502",
        "1/502",
        "1502",
        "1st battalion 502",
        "1st BN 502",
        "1-502 AIR",
        "1-502 PIR",
        "1/502 AIR"
      ],
      "label": "1st Battalion, 502nd Infantry Regiment",
      "tag": "AAC_UNIT_1502INF"
    },
    {
      "aliases": [
        "1503INF",
        "1st Battalion, 503rd Infantry Regiment",
        "1/503 Infantry",
        "1-503 Infantry",
        "First Rock",
        "1-503",
        "1/503",
        "1503",
        "1st battalion 503",
        "1st BN 503",
        "1-503 AIR",
        "1-503 PIR",
        "1/503 AIR"
      ],
      "label": "1st Battalion, 503rd Infantry Regiment",
      "tag": "AAC_UNIT_1503INF"
    },
    {
      "aliases": [
        "1504INF",
        "1st Battalion, 504th Parachute Infantry Regiment",
        "1-504",
        "1/504",
        "1504",
        "1st battalion 504",
        "1st BN 504",
        "1-504 AIR",
        "1-504 PIR",
        "1/504 AIR"
      ],
      "label": "1st Battalion, 504th Parachute Infantry Regiment",
      "tag": "AAC_UNIT_1504INF"
    },
    {
      "aliases": [
        "1505INF",
        "1st Battalion, 505th Parachute Infantry Regiment",
        "1-505",
        "1/505",
        "1505",
        "1st battalion 505",
        "1st BN 505",
        "1-505 AIR",
        "1-505 PIR",
        "1/505 AIR"
      ],
      "label": "1st Battalion, 505th Parachute Infantry Regiment",
      "tag": "AAC_UNIT_1505INF"
    },
    {
      "aliases": [
        "1506INF",
        "1st Battalion, 506th Infantry Regiment",
        "1/506 Infantry",
        "1-506 Infantry",
        "1/506 PIR",
        "Red Currahee",
        "1-506",
        "1/506",
        "1506",
        "1st battalion 506",
        "1st BN 506",
        "1-506 AIR",
        "1-506 PIR",
        "1/506 AIR"
      ],
      "label": "1st Battalion, 506th Infantry Regiment",
      "tag": "AAC_UNIT_1506INF"
    },
    {
      "aliases": [
        "1507INF",
        "1st Battalion, 507th Parachute Infantry Regiment",
        "1/507 PIR",
        "1-507th PIR",
        "1st Battalion, 507th Infantry Regiment",
        "First Panthers",
        "1-507",
        "1/507",
        "1507",
        "1st battalion 507",
        "1st BN 507",
        "1-507 AIR",
        "1-507 PIR",
        "1/507 AIR"
      ],
      "label": "1st Battalion, 507th Parachute Infantry Regiment",
      "tag": "AAC_UNIT_1507INF"
    },
    {
      "aliases": [
        "1508INF",
        "1st Battalion, 508th Parachute Infantry Regiment",
        "1/508 PIR",
        "1-508",
        "1/508",
        "1508",
        "1st battalion 508",
        "1st BN 508",
        "1-508 AIR",
        "1-508 PIR",
        "1/508 AIR"
      ],
      "label": "1st Battalion, 508th Parachute Infantry Regiment",
      "tag": "AAC_UNIT_1508INF"
    },
    {
      "aliases": [
        "1509INF",
        "1st Battalion, 509th Parachute Infantry Regiment",
        "1/509 PIR",
        "1-509",
        "1/509",
        "1509",
        "1st battalion 509",
        "1st BN 509",
        "1-509 AIR",
        "1-509 PIR",
        "1/509 AIR"
      ],
      "label": "1st Battalion, 509th Parachute Infantry Regiment",
      "tag": "AAC_UNIT_1509INF"
    },
    {
      "aliases": [
        "1511INF",
        "1st Battalion, 511th Parachute Infantry Regiment",
        "1-511",
        "1/511",
        "1511",
        "1st battalion 511",
        "1st BN 511",
        "1-511 AIR",
        "1-511 PIR",
        "1/511 AIR"
      ],
      "label": "1st Battalion, 511th Parachute Infantry Regiment",
      "tag": "AAC_UNIT_1511INF"
    },
    {
      "aliases": [
        "15SFG",
        "1st Battalion, 5th Special Forces Group (Airborne)",
        "1-5",
        "1/5",
        "15",
        "1st battalion 5",
        "1st BN 5"
      ],
      "label": "1st Battalion, 5th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_15SFG"
    },
    {
      "aliases": [
        "16SFG",
        "1st Battalion, 6th Special Forces Group (Airborne)",
        "1/6 SFG",
        "1-6th Special Forces Group",
        "1-6",
        "1/6",
        "16",
        "1st battalion 6",
        "1st BN 6"
      ],
      "label": "1st Battalion, 6th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_16SFG"
    },
    {
      "aliases": [
        "175INF",
        "1st Battalion, 75th Ranger Regiment",
        "1-75",
        "1/75",
        "175",
        "1st battalion 75",
        "1st BN 75"
      ],
      "label": "1st Battalion, 75th Ranger Regiment",
      "tag": "AAC_UNIT_175INF"
    },
    {
      "aliases": [
        "17SFG",
        "1st Battalion, 7th Special Forces Group (Airborne)",
        "1-7",
        "1/7",
        "17",
        "1st battalion 7",
        "1st BN 7"
      ],
      "label": "1st Battalion, 7th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_17SFG"
    },
    {
      "tag": "AAC_UNIT_18CAV",
      "label": "1st Battalion, 8th Cavalry Regiment",
      "aliases": [
        "18CAV",
        "1-8 CAV",
        "1/8 CAV",
        "1st Battalion 8th Cavalry",
        "1st BN 8 CAV"
      ]
    },
    {
      "tag": "AAC_UNIT_1CAV",
      "label": "1st Cavalry Division",
      "aliases": [
        "1CAV",
        "1st Cavalry Division",
        "1st Cav",
        "1 CAV",
        "First Team"
      ]
    },
    {
      "aliases": [
        "1SFG",
        "1st Special Forces Group (Airborne)",
        "1 SFG",
        "1st SFG",
        "1 Special Forces"
      ],
      "label": "1st Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_1SFG"
    },
    {
      "aliases": [
        "117CAV",
        "1st Squadron, 17th Cavalry Regiment (Airborne)",
        "1-17",
        "1/17",
        "117",
        "1st squadron 17",
        "1st SQDN 17",
        "1-17 CAV",
        "1/17 CAV"
      ],
      "label": "1st Squadron, 17th Cavalry Regiment (Airborne)",
      "tag": "AAC_UNIT_117CAV"
    },
    {
      "aliases": [
        "140CAV",
        "1st Squadron, 40th Cavalry Regiment (Airborne)",
        "1-40",
        "1/40",
        "140",
        "1st squadron 40",
        "1st SQDN 40",
        "1-40 CAV",
        "1/40 CAV"
      ],
      "label": "1st Squadron, 40th Cavalry Regiment (Airborne)",
      "tag": "AAC_UNIT_140CAV"
    },
    {
      "tag": "AAC_UNIT_173CAV",
      "label": "1st Squadron, 73rd Cavalry Regiment",
      "aliases": [
        "173CAV",
        "1-73 CAV",
        "1/73 CAV",
        "1st Squadron 73rd Cavalry",
        "1st Squadron, 73rd Cavalry Regiment"
      ]
    },
    {
      "aliases": [
        "191CAV",
        "1st Squadron, 91st Cavalry Regiment",
        "1-91",
        "1/91",
        "191",
        "1st squadron 91",
        "1st SQDN 91",
        "1-91 CAV",
        "1/91 CAV"
      ],
      "label": "1st Squadron, 91st Cavalry Regiment",
      "tag": "AAC_UNIT_191CAV"
    },
    {
      "aliases": [
        "20CBRNE",
        "20th CBRNE Command"
      ],
      "label": "20th CBRNE Command",
      "tag": "AAC_UNIT_20CBRNE"
    },
    {
      "aliases": [
        "20ENG",
        "20th ENGINEER BRIGADE"
      ],
      "label": "20th ENGINEER BRIGADE",
      "tag": "AAC_UNIT_20ENG"
    },
    {
      "aliases": [
        "20SFG",
        "20th Special Forces Group (Airborne)",
        "20 SFG",
        "20th SFG",
        "20 Special Forces"
      ],
      "label": "20th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_20SFG"
    },
    {
      "aliases": [
        "27ENG",
        "27th Engineer Battalion (Airborne)",
        "27th EN BN (A)",
        "27th Engineer Battalion",
        "27th Engineer Battalion (A)"
      ],
      "label": "27th Engineer Battalion",
      "tag": "AAC_UNIT_27ENG"
    },
    {
      "aliases": [
        "210SFG",
        "2nd Battalion, 10th Special Forces Group (Airborne)",
        "2-10",
        "2/10",
        "210",
        "2nd battalion 10",
        "2nd BN 10"
      ],
      "label": "2nd Battalion, 10th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_210SFG"
    },
    {
      "aliases": [
        "211SFG",
        "2nd Battalion, 11th Special Forces Group (Airborne)",
        "2/11 SFG",
        "2-11th Special Forces Group",
        "2-11",
        "2/11",
        "211",
        "2nd battalion 11",
        "2nd BN 11"
      ],
      "label": "2nd Battalion, 11th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_211SFG"
    },
    {
      "aliases": [
        "212SFG",
        "2nd Battalion, 12th Special Forces Group (Airborne)",
        "2/12 SFG",
        "2-12th Special Forces Group",
        "2-12",
        "2/12",
        "212",
        "2nd battalion 12",
        "2nd BN 12"
      ],
      "label": "2nd Battalion, 12th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_212SFG"
    },
    {
      "aliases": [
        "2187INF",
        "2nd Battalion, 187th Infantry Regiment",
        "2/187 Infantry",
        "2-187 Infantry",
        "Rakkasan Raiders",
        "2-187",
        "2/187",
        "2187",
        "2nd battalion 187",
        "2nd BN 187",
        "2-187 AIR",
        "2-187 PIR",
        "2/187 AIR"
      ],
      "label": "2nd Battalion, 187th Infantry Regiment",
      "tag": "AAC_UNIT_2187INF"
    },
    {
      "aliases": [
        "219SFG",
        "2nd Battalion, 19th Special Forces Group (Airborne)",
        "2-19",
        "2/19",
        "219",
        "2nd battalion 19",
        "2nd BN 19"
      ],
      "label": "2nd Battalion, 19th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_219SFG"
    },
    {
      "aliases": [
        "21SFG",
        "2nd Battalion, 1st Special Forces Group (Airborne)",
        "2-1",
        "2/1",
        "21",
        "2nd battalion 1",
        "2nd BN 1"
      ],
      "label": "2nd Battalion, 1st Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_21SFG"
    },
    {
      "aliases": [
        "220SFG",
        "2nd Battalion, 20th Special Forces Group (Airborne)",
        "2-20",
        "2/20",
        "220",
        "2nd battalion 20",
        "2nd BN 20"
      ],
      "label": "2nd Battalion, 20th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_220SFG"
    },
    {
      "aliases": [
        "2319FAR",
        "2-319",
        "2/319",
        "2nd Battalion, 319th AFAR",
        "2-319 AFAR",
        "2nd BN 319"
      ],
      "label": "2nd Battalion, 319th Airborne Field Artillery Regiment",
      "tag": "AAC_UNIT_2319FAR"
    },
    {
      "aliases": [
        "2321FAR",
        "2nd Battalion, 321st Airborne Field Artillery Regiment",
        "2-321",
        "2/321",
        "2321",
        "2nd battalion 321",
        "2nd BN 321",
        "2-321 AIR",
        "2-321 PIR",
        "2/321 AIR"
      ],
      "label": "2nd Battalion, 321st Airborne Field Artillery Regiment",
      "tag": "AAC_UNIT_2321FAR"
    },
    {
      "aliases": [
        "2325INF",
        "2nd Battalion, 325th Airborne Infantry Regiment",
        "2/325 AIR",
        "2-325",
        "2/325",
        "2nd BN 325 AIR",
        "2-325AIR",
        "White Falcons",
        "2325",
        "2nd battalion 325",
        "2nd BN 325",
        "2-325 AIR",
        "2-325 PIR"
      ],
      "label": "2nd Battalion, 325th Airborne Infantry Regiment",
      "tag": "AAC_UNIT_2325INF"
    },
    {
      "aliases": [
        "2327INF",
        "2nd Battalion, 327th Infantry Regiment",
        "2/327 Infantry",
        "2-327 Infantry",
        "No Slack",
        "2-327",
        "2/327",
        "2327",
        "2nd battalion 327",
        "2nd BN 327",
        "2-327 AIR",
        "2-327 PIR",
        "2/327 AIR"
      ],
      "label": "2nd Battalion, 327th Infantry Regiment",
      "tag": "AAC_UNIT_2327INF"
    },
    {
      "aliases": [
        "23SFG",
        "2nd Battalion, 3rd Special Forces Group (Airborne)",
        "2-3",
        "2/3",
        "23",
        "2nd battalion 3",
        "2nd BN 3"
      ],
      "label": "2nd Battalion, 3rd Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_23SFG"
    },
    {
      "aliases": [
        "2501INF",
        "2nd Battalion, 501st Infantry Regiment",
        "2/501 PIR",
        "2-501 PIR",
        "2-501",
        "2/501",
        "2501",
        "2nd battalion 501",
        "2nd BN 501",
        "2-501 AIR",
        "2/501 AIR"
      ],
      "label": "2nd Battalion, 501st Infantry Regiment",
      "tag": "AAC_UNIT_2501INF"
    },
    {
      "aliases": [
        "2502INF",
        "2nd Battalion, 502nd Infantry Regiment",
        "2/502 Infantry",
        "2-502 Infantry",
        "2/502 PIR",
        "2-502",
        "2/502",
        "2502",
        "2nd battalion 502",
        "2nd BN 502",
        "2-502 AIR",
        "2-502 PIR",
        "2/502 AIR"
      ],
      "label": "2nd Battalion, 502nd Infantry Regiment",
      "tag": "AAC_UNIT_2502INF"
    },
    {
      "aliases": [
        "2503INF",
        "2nd Battalion, 503rd Infantry Regiment",
        "2/503 Infantry",
        "2-503 Infantry",
        "The Rock",
        "2-503",
        "2/503",
        "2503",
        "2nd battalion 503",
        "2nd BN 503",
        "2-503 AIR",
        "2-503 PIR",
        "2/503 AIR"
      ],
      "label": "2nd Battalion, 503rd Infantry Regiment",
      "tag": "AAC_UNIT_2503INF"
    },
    {
      "aliases": [
        "2504INF",
        "2nd Battalion, 504th Parachute Infantry Regiment",
        "2-504",
        "2/504",
        "2504",
        "2nd battalion 504",
        "2nd BN 504",
        "2-504 AIR",
        "2-504 PIR",
        "2/504 AIR"
      ],
      "label": "2nd Battalion, 504th Parachute Infantry Regiment",
      "tag": "AAC_UNIT_2504INF"
    },
    {
      "aliases": [
        "2505INF",
        "2nd Battalion, 505th Parachute Infantry Regiment",
        "2-505",
        "2/505",
        "2505",
        "2nd battalion 505",
        "2nd BN 505",
        "2-505 AIR",
        "2-505 PIR",
        "2/505 AIR"
      ],
      "label": "2nd Battalion, 505th Parachute Infantry Regiment",
      "tag": "AAC_UNIT_2505INF"
    },
    {
      "aliases": [
        "2506INF",
        "2nd Battalion, 506th Infantry Regiment",
        "2/506 Infantry",
        "2-506 Infantry",
        "2/506 PIR",
        "White Currahee",
        "2-506",
        "2/506",
        "2506",
        "2nd battalion 506",
        "2nd BN 506",
        "2-506 AIR",
        "2-506 PIR",
        "2/506 AIR"
      ],
      "label": "2nd Battalion, 506th Infantry Regiment",
      "tag": "AAC_UNIT_2506INF"
    },
    {
      "aliases": [
        "2508INF",
        "2nd Battalion, 508th Parachute Infantry Regiment",
        "2/508 PIR",
        "2-508",
        "2/508",
        "2508",
        "2nd battalion 508",
        "2nd BN 508",
        "2-508 AIR",
        "2-508 PIR",
        "2/508 AIR"
      ],
      "label": "2nd Battalion, 508th Parachute Infantry Regiment",
      "tag": "AAC_UNIT_2508INF"
    },
    {
      "aliases": [
        "2509INF",
        "2nd Battalion, 509th Parachute Infantry Regiment",
        "2/509 PIR",
        "2-509",
        "2/509",
        "2509",
        "2nd battalion 509",
        "2nd BN 509",
        "2-509 AIR",
        "2-509 PIR",
        "2/509 AIR"
      ],
      "label": "2nd Battalion, 509th Parachute Infantry Regiment",
      "tag": "AAC_UNIT_2509INF"
    },
    {
      "aliases": [
        "25SFG",
        "2nd Battalion, 5th Special Forces Group (Airborne)",
        "2-5",
        "2/5",
        "25",
        "2nd battalion 5",
        "2nd BN 5"
      ],
      "label": "2nd Battalion, 5th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_25SFG"
    },
    {
      "aliases": [
        "26SFG",
        "2nd Battalion, 6th Special Forces Group (Airborne)",
        "2/6 SFG",
        "2-6th Special Forces Group",
        "2-6",
        "2/6",
        "26",
        "2nd battalion 6",
        "2nd BN 6"
      ],
      "label": "2nd Battalion, 6th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_26SFG"
    },
    {
      "aliases": [
        "275INF",
        "2nd Battalion, 75th Ranger Regiment",
        "2-75",
        "2/75",
        "275",
        "2nd battalion 75",
        "2nd BN 75"
      ],
      "label": "2nd Battalion, 75th Ranger Regiment",
      "tag": "AAC_UNIT_275INF"
    },
    {
      "aliases": [
        "27SFG",
        "2nd Battalion, 7th Special Forces Group (Airborne)",
        "2-7",
        "2/7",
        "27",
        "2nd battalion 7",
        "2nd BN 7"
      ],
      "label": "2nd Battalion, 7th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_27SFG"
    },
    {
      "tag": "AAC_UNIT_28CAV",
      "label": "2nd Battalion, 8th Cavalry Regiment",
      "aliases": [
        "28CAV",
        "2-8 CAV",
        "2/8 CAV",
        "2nd Battalion 8th Cavalry",
        "2nd BN 8 CAV"
      ]
    },
    {
      "aliases": [
        "2POG",
        "2nd Psychological Operations Group (Airborne)"
      ],
      "label": "2nd Psychological Operations Group (Airborne)",
      "tag": "AAC_UNIT_2POG"
    },
    {
      "aliases": [
        "307ENG",
        "307th Engineer Battalion"
      ],
      "label": "307th Engineer Battalion",
      "tag": "AAC_UNIT_307ENG"
    },
    {
      "aliases": [
        "307FSB",
        "307th Forward Support Battalion"
      ],
      "label": "307th Forward Support Battalion",
      "tag": "AAC_UNIT_307FSB"
    },
    {
      "aliases": [
        "307MED",
        "307th Medical Battalion",
        "Headquarters and Support Company, 307th Medical Battalion"
      ],
      "label": "307th Medical Battalion",
      "tag": "AAC_UNIT_307MED"
    },
    {
      "aliases": [
        "311MI",
        "311th Military Intelligence Battalion"
      ],
      "label": "311th Military Intelligence Battalion",
      "tag": "AAC_UNIT_311MI"
    },
    {
      "aliases": [
        "313MI",
        "313th Military Intelligence Battalion"
      ],
      "label": "313th Military Intelligence Battalion",
      "tag": "AAC_UNIT_313MI"
    },
    {
      "aliases": [
        "319FAR",
        "319AFAR",
        "319FA",
        "319th Airborne Field Artillery Regiment",
        "319th AFAR",
        "319 AFAR",
        "319th Field Artillery",
        "319th Airborne Artillery"
      ],
      "label": "319th Airborne Field Artillery Regiment",
      "tag": "AAC_UNIT_319FAR"
    },
    {
      "aliases": [
        "320FA",
        "320th Field Artillery Regiment",
        "320 Field Artillery",
        "320th Field Artillery"
      ],
      "label": "320th Field Artillery Regiment",
      "tag": "AAC_UNIT_320FA"
    },
    {
      "aliases": [
        "321FA",
        "321st Field Artillery Regiment",
        "321 Field Artillery",
        "321st Field Artillery"
      ],
      "label": "321st Field Artillery Regiment",
      "tag": "AAC_UNIT_321FA"
    },
    {
      "aliases": [
        "325INF",
        "325th Airborne Infantry Regiment",
        "325th AIR",
        "325th Infantry Regiment",
        "325 AIR",
        "325 Infantry",
        "325th Airborne",
        "325 Airborne",
        "325 Airborne Infantry",
        "325th Airborne Infantry",
        "325 PIR",
        "325th Infantry"
      ],
      "label": "325th Airborne Infantry Regiment",
      "tag": "AAC_UNIT_325INF"
    },
    {
      "tag": "AAC_UNIT_345PSY",
      "label": "345th Tactical Psychological Operations Company (Airborne)",
      "aliases": [
        "345PSY",
        "345th Tactical PSYOP Company",
        "345th PSYOP Company",
        "345 PSY",
        "345th TPC"
      ]
    },
    {
      "aliases": [
        "353CA",
        "353rd Civil Affairs Command"
      ],
      "label": "353rd Civil Affairs Command",
      "tag": "AAC_UNIT_353CA"
    },
    {
      "aliases": [
        "353POB",
        "353rd Psychological Operations Battalion",
        "353rd PSYOP Battalion",
        "353rd POB"
      ],
      "label": "353rd Psychological Operations Battalion",
      "tag": "AAC_UNIT_353POB"
    },
    {
      "aliases": [
        "35SIG",
        "35th Signal Brigade"
      ],
      "label": "35th Signal Brigade",
      "tag": "AAC_UNIT_35SIG"
    },
    {
      "aliases": [
        "360CA",
        "360th Civil Affairs Brigade"
      ],
      "label": "360th Civil Affairs Brigade",
      "tag": "AAC_UNIT_360CA"
    },
    {
      "aliases": [
        "37ENG",
        "37th Engineer Battalion"
      ],
      "label": "37th Engineer Battalion",
      "tag": "AAC_UNIT_37ENG"
    },
    {
      "aliases": [
        "3ANGLICO",
        "3rd Air Naval Gunfire Liaison Company"
      ],
      "label": "3rd Air Naval Gunfire Liaison Company",
      "tag": "AAC_UNIT_3ANGLICO"
    },
    {
      "aliases": [
        "310SFG",
        "3rd Battalion, 10th Special Forces Group (Airborne)",
        "3-10",
        "3/10",
        "310",
        "3rd battalion 10",
        "3rd BN 10"
      ],
      "label": "3rd Battalion, 10th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_310SFG"
    },
    {
      "aliases": [
        "311SFG",
        "3rd Battalion, 11th Special Forces Group (Airborne)",
        "3/11 SFG",
        "3-11th Special Forces Group",
        "3-11",
        "3/11",
        "311",
        "3rd battalion 11",
        "3rd BN 11"
      ],
      "label": "3rd Battalion, 11th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_311SFG"
    },
    {
      "aliases": [
        "312SFG",
        "3rd Battalion, 12th Special Forces Group (Airborne)",
        "3/12 SFG",
        "3-12th Special Forces Group",
        "3-12",
        "3/12",
        "312",
        "3rd battalion 12",
        "3rd BN 12"
      ],
      "label": "3rd Battalion, 12th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_312SFG"
    },
    {
      "aliases": [
        "3187INF",
        "3rd Battalion, 187th Infantry Regiment",
        "3/187 Infantry",
        "3-187 Infantry",
        "Iron Rakkasans",
        "3-187",
        "3/187",
        "3187",
        "3rd battalion 187",
        "3rd BN 187",
        "3-187 AIR",
        "3-187 PIR",
        "3/187 AIR"
      ],
      "label": "3rd Battalion, 187th Infantry Regiment",
      "tag": "AAC_UNIT_3187INF"
    },
    {
      "aliases": [
        "31SFG",
        "3rd Battalion, 1st Special Forces Group (Airborne)",
        "3-1",
        "3/1",
        "31",
        "3rd battalion 1",
        "3rd BN 1"
      ],
      "label": "3rd Battalion, 1st Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_31SFG"
    },
    {
      "aliases": [
        "320SFG",
        "3rd Battalion, 20th Special Forces Group (Airborne)",
        "3-20",
        "3/20",
        "320",
        "3rd battalion 20",
        "3rd BN 20"
      ],
      "label": "3rd Battalion, 20th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_320SFG"
    },
    {
      "aliases": [
        "3319FAR",
        "3-319",
        "3/319",
        "3rd Battalion, 319th AFAR",
        "3-319 AFAR",
        "3rd BN 319",
        "Gun Devils"
      ],
      "label": "3rd Battalion, 319th Airborne Field Artillery Regiment",
      "tag": "AAC_UNIT_3319FAR"
    },
    {
      "aliases": [
        "3325INF",
        "3rd Battalion, 325th Airborne Infantry Regiment",
        "3/325 AIR",
        "3-325",
        "3/325",
        "3rd BN 325 AIR",
        "3-325AIR",
        "3/325 ABCT",
        "3325",
        "3rd battalion 325",
        "3rd BN 325",
        "3-325 AIR",
        "3-325 PIR"
      ],
      "label": "3rd Battalion, 325th Airborne Infantry Regiment",
      "tag": "AAC_UNIT_3325INF"
    },
    {
      "aliases": [
        "33SFG",
        "3rd Battalion, 3rd Special Forces Group (Airborne)",
        "3-3",
        "3/3",
        "33",
        "3rd battalion 3",
        "3rd BN 3"
      ],
      "label": "3rd Battalion, 3rd Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_33SFG"
    },
    {
      "aliases": [
        "34ADA",
        "3rd Battalion, 4th Air Defense Artillery Regiment",
        "3-4",
        "3/4",
        "34",
        "3rd battalion 4",
        "3rd BN 4"
      ],
      "label": "3rd Battalion, 4th Air Defense Artillery Regiment",
      "tag": "AAC_UNIT_34ADA"
    },
    {
      "aliases": [
        "3504INF",
        "3rd Battalion, 504th Parachute Infantry Regiment",
        "3/504 PIR",
        "3-504",
        "3/504",
        "3504",
        "3rd battalion 504",
        "3rd BN 504",
        "3-504 AIR",
        "3-504 PIR",
        "3/504 AIR"
      ],
      "label": "3rd Battalion, 504th Parachute Infantry Regiment",
      "tag": "AAC_UNIT_3504INF"
    },
    {
      "aliases": [
        "3505INF",
        "3rd Battalion, 505th Parachute Infantry Regiment",
        "3-505",
        "3/505",
        "3505",
        "3rd battalion 505",
        "3rd BN 505",
        "3-505 AIR",
        "3-505 PIR",
        "3/505 AIR"
      ],
      "label": "3rd Battalion, 505th Parachute Infantry Regiment",
      "tag": "AAC_UNIT_3505INF"
    },
    {
      "aliases": [
        "3508INF",
        "3rd Battalion, 508th Parachute Infantry Regiment",
        "3/508 PIR",
        "3-508",
        "3/508",
        "3508",
        "3rd battalion 508",
        "3rd BN 508",
        "3-508 AIR",
        "3-508 PIR",
        "3/508 AIR"
      ],
      "label": "3rd Battalion, 508th Parachute Infantry Regiment",
      "tag": "AAC_UNIT_3508INF"
    },
    {
      "aliases": [
        "3509INF",
        "3rd Battalion, 509th Parachute Infantry Regiment",
        "3/509 PIR",
        "3-509",
        "3/509",
        "3509",
        "3rd battalion 509",
        "3rd BN 509",
        "3-509 AIR",
        "3-509 PIR",
        "3/509 AIR"
      ],
      "label": "3rd Battalion, 509th Parachute Infantry Regiment",
      "tag": "AAC_UNIT_3509INF"
    },
    {
      "aliases": [
        "35SFG",
        "3rd Battalion, 5th Special Forces Group (Airborne)",
        "3-5",
        "3/5",
        "35",
        "3rd battalion 5",
        "3rd BN 5"
      ],
      "label": "3rd Battalion, 5th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_35SFG"
    },
    {
      "aliases": [
        "36SFG",
        "3rd Battalion, 6th Special Forces Group (Airborne)",
        "3/6 SFG",
        "3-6th Special Forces Group",
        "3-6",
        "3/6",
        "36",
        "3rd battalion 6",
        "3rd BN 6"
      ],
      "label": "3rd Battalion, 6th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_36SFG"
    },
    {
      "aliases": [
        "373AR",
        "3rd Battalion, 73rd Armor Regiment",
        "3-73",
        "3/73",
        "373",
        "3rd battalion 73",
        "3rd BN 73"
      ],
      "label": "3rd Battalion, 73rd Armor Regiment",
      "tag": "AAC_UNIT_373AR"
    },
    {
      "aliases": [
        "375INF",
        "3rd Battalion, 75th Ranger Regiment",
        "3-75",
        "3/75",
        "375",
        "3rd battalion 75",
        "3rd BN 75"
      ],
      "label": "3rd Battalion, 75th Ranger Regiment",
      "tag": "AAC_UNIT_375INF"
    },
    {
      "aliases": [
        "37SFG",
        "3rd Battalion, 7th Special Forces Group (Airborne)",
        "3-7",
        "3/7",
        "37",
        "3rd battalion 7",
        "3rd BN 7"
      ],
      "label": "3rd Battalion, 7th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_37SFG"
    },
    {
      "aliases": [
        "382CAB",
        "3rd Combat Aviation Brigade, 82nd Airborne Division"
      ],
      "label": "3rd Combat Aviation Brigade, 82nd Airborne Division",
      "tag": "AAC_UNIT_382CAB"
    },
    {
      "aliases": [
        "3POB",
        "3rd Psychological Operations Battalion (Airborne)",
        "3rd PSYOP Battalion (Airborne)",
        "3rd POB"
      ],
      "label": "3rd Psychological Operations Battalion (Airborne)",
      "tag": "AAC_UNIT_3POB"
    },
    {
      "aliases": [
        "3SFG",
        "3rd Special Forces Group (Airborne)",
        "3 SFG",
        "3rd SFG",
        "3 Special Forces"
      ],
      "label": "3rd Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_3SFG"
    },
    {
      "tag": "AAC_UNIT_373CAV",
      "label": "3rd Squadron, 73rd Cavalry Regiment",
      "aliases": [
        "373CAV",
        "3-73 CAV",
        "3/73 CAV",
        "3rd Squadron 73rd Cavalry",
        "3rd Squadron, 73rd Cavalry Regiment"
      ]
    },
    {
      "aliases": [
        "401FS",
        "401st Fighter Squadron"
      ],
      "label": "401st Fighter Squadron",
      "tag": "AAC_UNIT_401FS"
    },
    {
      "aliases": [
        "407FSB",
        "407th Forward Support Battalion"
      ],
      "label": "407th Forward Support Battalion",
      "tag": "AAC_UNIT_407FSB"
    },
    {
      "aliases": [
        "412CA",
        "412th Civil Affairs Battalion"
      ],
      "label": "412th Civil Affairs Battalion",
      "tag": "AAC_UNIT_412CA"
    },
    {
      "aliases": [
        "44MED",
        "44th Medical Brigade"
      ],
      "label": "44th Medical Brigade",
      "tag": "AAC_UNIT_44MED"
    },
    {
      "aliases": [
        "410SFG",
        "4th Battalion, 10th Special Forces Group (Airborne)",
        "4-10",
        "4/10",
        "410",
        "4th battalion 10",
        "4th BN 10"
      ],
      "label": "4th Battalion, 10th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_410SFG"
    },
    {
      "aliases": [
        "41SFG",
        "4th Battalion, 1st Special Forces Group (Airborne)",
        "4-1",
        "4/1",
        "41",
        "4th battalion 1",
        "4th BN 1"
      ],
      "label": "4th Battalion, 1st Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_41SFG"
    },
    {
      "aliases": [
        "420SFG",
        "4th Battalion, 20th Special Forces Group (Airborne)",
        "4-20",
        "4/20",
        "420",
        "4th battalion 20",
        "4th BN 20"
      ],
      "label": "4th Battalion, 20th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_420SFG"
    },
    {
      "aliases": [
        "4319FAR",
        "4-319",
        "4/319",
        "4th Battalion, 319th AFAR",
        "4-319 AFAR",
        "4th BN 319"
      ],
      "label": "4th Battalion, 319th Airborne Field Artillery Regiment",
      "tag": "AAC_UNIT_4319FAR"
    },
    {
      "aliases": [
        "4325INF",
        "4th Battalion, 325th Airborne Infantry Regiment",
        "4/325 AIR",
        "4-325",
        "4/325",
        "4th BN 325 AIR",
        "4-325AIR",
        "Gold Falcons",
        "4325",
        "4th battalion 325",
        "4th BN 325",
        "4-325 AIR",
        "4-325 PIR"
      ],
      "label": "4th Battalion, 325th Airborne Infantry Regiment",
      "tag": "AAC_UNIT_4325INF"
    },
    {
      "aliases": [
        "43SFG",
        "4th Battalion, 3rd Special Forces Group (Airborne)",
        "4-3",
        "4/3",
        "43",
        "4th battalion 3",
        "4th BN 3"
      ],
      "label": "4th Battalion, 3rd Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_43SFG"
    },
    {
      "aliases": [
        "45SFG",
        "4th Battalion, 5th Special Forces Group (Airborne)",
        "4-5",
        "4/5",
        "45",
        "4th battalion 5",
        "4th BN 5"
      ],
      "label": "4th Battalion, 5th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_45SFG"
    },
    {
      "aliases": [
        "468AR",
        "4th Battalion, 68th Armor Regiment",
        "4-68",
        "4/68",
        "468",
        "4th battalion 68",
        "4th BN 68"
      ],
      "label": "4th Battalion, 68th Armor Regiment",
      "tag": "AAC_UNIT_468AR"
    },
    {
      "aliases": [
        "477ARA",
        "4th Battalion, 77th Aerial Rocket Artillery Regiment",
        "4-77",
        "4/77",
        "477",
        "4th battalion 77",
        "4th BN 77"
      ],
      "label": "4th Battalion, 77th Aerial Rocket Artillery Regiment",
      "tag": "AAC_UNIT_477ARA"
    },
    {
      "aliases": [
        "47SFG",
        "4th Battalion, 7th Special Forces Group (Airborne)",
        "4-7",
        "4/7",
        "47",
        "4th battalion 7",
        "4th BN 7"
      ],
      "label": "4th Battalion, 7th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_47SFG"
    },
    {
      "aliases": [
        "4POG",
        "4th Psychological Operations Group (Airborne)"
      ],
      "label": "4th Psychological Operations Group (Airborne)",
      "tag": "AAC_UNIT_4POG"
    },
    {
      "tag": "AAC_UNIT_473CAV",
      "label": "4th Squadron, 73rd Cavalry Regiment",
      "aliases": [
        "473CAV",
        "4-73 CAV",
        "4/73 CAV",
        "4th Squadron 73rd Cavalry",
        "4th Squadron, 73rd Cavalry Regiment"
      ]
    },
    {
      "aliases": [
        "4SBN",
        "4th Student Battalion (Airborne)",
        "4th Student Battalion (ABN)",
        "4th Student Battalion TSB (ABN)",
        "4th Airborne Training Battalion"
      ],
      "label": "4th Student Battalion (Airborne)",
      "tag": "AAC_UNIT_4SBN"
    },
    {
      "aliases": [
        "501INF",
        "501st Infantry Regiment",
        "501 Infantry",
        "501st Infantry",
        "501 Airborne",
        "501 AIR",
        "501 PIR"
      ],
      "label": "501st Infantry Regiment",
      "tag": "AAC_UNIT_501INF"
    },
    {
      "aliases": [
        "502INF",
        "502nd Infantry Regiment",
        "502 Infantry",
        "502nd Infantry",
        "502 Airborne",
        "502 AIR",
        "502 PIR"
      ],
      "label": "502nd Infantry Regiment",
      "tag": "AAC_UNIT_502INF"
    },
    {
      "aliases": [
        "503INF",
        "503rd Infantry Regiment",
        "503rd Parachute Infantry Regiment",
        "503rd PIR",
        "The Rock",
        "503 Infantry",
        "503rd Infantry",
        "503 Airborne",
        "503 AIR",
        "503 PIR"
      ],
      "label": "503rd Infantry Regiment",
      "tag": "AAC_UNIT_503INF"
    },
    {
      "aliases": [
        "504INF",
        "504th Parachute Infantry Regiment",
        "504 Parachute Infantry",
        "504th Parachute Infantry",
        "504 Infantry",
        "504 Airborne",
        "504 AIR",
        "504 PIR"
      ],
      "label": "504th Parachute Infantry Regiment",
      "tag": "AAC_UNIT_504INF"
    },
    {
      "aliases": [
        "505INF",
        "505th Parachute Infantry Regiment",
        "505 Parachute Infantry",
        "505th Parachute Infantry",
        "505 Infantry",
        "505 Airborne",
        "505 AIR",
        "505 PIR"
      ],
      "label": "505th Parachute Infantry Regiment",
      "tag": "AAC_UNIT_505INF"
    },
    {
      "aliases": [
        "506INF",
        "506th Infantry Regiment",
        "506th Parachute Infantry Regiment",
        "506th PIR",
        "Currahee",
        "506 Infantry",
        "506th Infantry",
        "506 Airborne",
        "506 AIR",
        "506 PIR"
      ],
      "label": "506th Infantry Regiment",
      "tag": "AAC_UNIT_506INF"
    },
    {
      "aliases": [
        "507INF",
        "507th Parachute Infantry Regiment",
        "507th PIR",
        "507th Infantry Regiment",
        "507 Parachute Infantry",
        "507th Parachute Infantry",
        "507 Infantry",
        "507 Airborne",
        "507 AIR",
        "507 PIR",
        "507th Infantry"
      ],
      "label": "507th Infantry Regiment",
      "tag": "AAC_UNIT_507INF"
    },
    {
      "aliases": [
        "508INF",
        "508th Parachute Infantry Regiment",
        "508 Parachute Infantry",
        "508th Parachute Infantry",
        "508 Infantry",
        "508 Airborne",
        "508 AIR",
        "508 PIR"
      ],
      "label": "508th Parachute Infantry Regiment",
      "tag": "AAC_UNIT_508INF"
    },
    {
      "aliases": [
        "508STB",
        "508th Special Troops Battalion"
      ],
      "label": "508th Special Troops Battalion",
      "tag": "AAC_UNIT_508STB"
    },
    {
      "aliases": [
        "509INF",
        "509th Parachute Infantry Regiment",
        "509 Parachute Infantry",
        "509th Parachute Infantry",
        "509 Infantry",
        "509 Airborne",
        "509 AIR",
        "509 PIR",
        "509th Parachute Infantry Battalion",
        "509th PIB"
      ],
      "label": "509th Parachute Infantry Regiment",
      "tag": "AAC_UNIT_509INF"
    },
    {
      "aliases": [
        "50SIG",
        "50th Signal Battalion"
      ],
      "label": "50th Signal Battalion",
      "tag": "AAC_UNIT_50SIG"
    },
    {
      "aliases": [
        "511INF",
        "511th Parachute Infantry Regiment",
        "511 Parachute Infantry",
        "511th Parachute Infantry",
        "511 Infantry",
        "511 Airborne",
        "511 AIR",
        "511 PIR"
      ],
      "label": "511th Parachute Infantry Regiment",
      "tag": "AAC_UNIT_511INF"
    },
    {
      "aliases": [
        "551INF",
        "551st Infantry Regiment",
        "551 Infantry",
        "551st Infantry",
        "551 Airborne",
        "551 AIR",
        "551 PIR"
      ],
      "label": "551st Infantry Regiment",
      "tag": "AAC_UNIT_551INF"
    },
    {
      "tag": "AAC_UNIT_551PIB",
      "label": "551st Parachute Infantry Battalion (Separate)",
      "aliases": [
        "551PIB",
        "551st Parachute Infantry Battalion",
        "551st PIB",
        "551 PIB",
        "GOYA"
      ]
    },
    {
      "aliases": [
        "555INF",
        "555th Infantry Regiment",
        "555 Infantry",
        "555th Infantry",
        "555 Airborne",
        "555 AIR",
        "555 PIR"
      ],
      "label": "555th Infantry Regiment",
      "tag": "AAC_UNIT_555INF"
    },
    {
      "aliases": [
        "555PIB",
        "555th Parachute Infantry Battalion"
      ],
      "label": "555th Parachute Infantry Battalion",
      "tag": "AAC_UNIT_555PIB"
    },
    {
      "aliases": [
        "519SFG",
        "5th Battalion, 19th Special Forces Group (Airborne)",
        "5/19 SFG",
        "5-19th Special Forces Group",
        "5-19",
        "5/19",
        "519",
        "5th battalion 19",
        "5th BN 19"
      ],
      "label": "5th Battalion, 19th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_519SFG"
    },
    {
      "tag": "AAC_UNIT_5POB",
      "label": "5th Psychological Operations Battalion (Airborne)",
      "aliases": [
        "5POB",
        "5th Psychological Operations Battalion",
        "5th PSYOP Battalion",
        "5 POB",
        "5th POB"
      ]
    },
    {
      "aliases": [
        "5SFG",
        "5th Special Forces Group (Airborne)",
        "5 SFG",
        "5th SFG",
        "5 Special Forces"
      ],
      "label": "5th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_5SFG"
    },
    {
      "aliases": [
        "573CAV",
        "5th Squadron, 73rd Cavalry Regiment",
        "5-73",
        "5/73",
        "573",
        "5th squadron 73",
        "5th SQDN 73",
        "5-73 CAV",
        "5/73 CAV"
      ],
      "label": "5th Squadron, 73rd Cavalry Regiment",
      "tag": "AAC_UNIT_573CAV"
    },
    {
      "aliases": [
        "618ENG",
        "618th Engineer Company"
      ],
      "label": "618th Engineer Company",
      "tag": "AAC_UNIT_618ENG"
    },
    {
      "tag": "AAC_UNIT_6POB",
      "label": "6th Psychological Operations Battalion (Airborne)",
      "aliases": [
        "6POB",
        "6th Psychological Operations Battalion",
        "6th PSYOP Battalion",
        "6 POB",
        "6th POB"
      ]
    },
    {
      "aliases": [
        "6SFG",
        "6th Special Forces Group (Airborne)",
        "6 SFG",
        "6th SFG",
        "6 Special Forces"
      ],
      "label": "6th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_6SFG"
    },
    {
      "aliases": [
        "74LRS",
        "74th Long Range Surveillance Detachment"
      ],
      "label": "74th Long Range Surveillance Detachment",
      "tag": "AAC_UNIT_74LRS"
    },
    {
      "aliases": [
        "782MSB",
        "782nd Maintenance Battalion"
      ],
      "label": "782nd Maintenance Battalion",
      "tag": "AAC_UNIT_782MSB"
    },
    {
      "aliases": [
        "7POG",
        "7th Psychological Operations Group (Airborne)"
      ],
      "label": "7th Psychological Operations Group (Airborne)",
      "tag": "AAC_UNIT_7POG"
    },
    {
      "aliases": [
        "7SFG",
        "7th Special Forces Group (Airborne)",
        "7 SFG",
        "7th SFG",
        "7 Special Forces"
      ],
      "label": "7th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_7SFG"
    },
    {
      "tag": "AAC_UNIT_80AAA",
      "label": "80th Airborne Anti-Aircraft Artillery Battalion",
      "aliases": [
        "80AAA",
        "80th Airborne Anti-Aircraft Battalion",
        "80th AAA",
        "80 AAA",
        "80th Airborne AAA"
      ]
    },
    {
      "aliases": [
        "82ABN",
        "82nd Airborne Division",
        "82 Airborne",
        "82nd Airborne",
        "82 ABN",
        "82nd ABN"
      ],
      "label": "82nd Airborne Division",
      "tag": "AAC_UNIT_82ABN"
    },
    {
      "aliases": [
        "82LRRP",
        "82nd Airborne Division Long Range Reconnaissance Patrol",
        "82 Airborne",
        "82nd Airborne",
        "82 ABN",
        "82nd ABN"
      ],
      "label": "82nd Airborne Division Long Range Reconnaissance Patrol",
      "tag": "AAC_UNIT_82LRRP"
    },
    {
      "aliases": [
        "82AV",
        "82nd Aviation Regiment",
        "82 Aviation",
        "82nd Aviation"
      ],
      "label": "82nd Aviation Regiment",
      "tag": "AAC_UNIT_82AV"
    },
    {
      "aliases": [
        "82BSB",
        "82nd Brigade Support Battalion"
      ],
      "label": "82nd Brigade Support Battalion",
      "tag": "AAC_UNIT_82BSB"
    },
    {
      "aliases": [
        "82CAB",
        "82nd Combat Aviation Brigade"
      ],
      "label": "82nd Combat Aviation Brigade",
      "tag": "AAC_UNIT_82CAB"
    },
    {
      "aliases": [
        "82FIN",
        "82nd Finance Battalion"
      ],
      "label": "82nd Finance Battalion",
      "tag": "AAC_UNIT_82FIN"
    },
    {
      "aliases": [
        "82FSB",
        "82nd Forward Support Battalion"
      ],
      "label": "82nd Forward Support Battalion",
      "tag": "AAC_UNIT_82FSB"
    },
    {
      "aliases": [
        "82MPCO",
        "82nd Military Police Company"
      ],
      "label": "82nd Military Police Company",
      "tag": "AAC_UNIT_82MPCO"
    },
    {
      "aliases": [
        "82REPL",
        "82nd Replacement Detachment"
      ],
      "label": "82nd Replacement Detachment",
      "tag": "AAC_UNIT_82REPL"
    },
    {
      "aliases": [
        "82SIG",
        "82nd Signal Battalion"
      ],
      "label": "82nd Signal Battalion",
      "tag": "AAC_UNIT_82SIG"
    },
    {
      "aliases": [
        "82SSB",
        "82nd Soldier Support Battalion"
      ],
      "label": "82nd Soldier Support Battalion",
      "tag": "AAC_UNIT_82SSB"
    },
    {
      "tag": "AAC_UNIT_8CAV",
      "label": "8th Cavalry Regiment",
      "aliases": [
        "8CAV",
        "8th Cavalry Regiment",
        "8th Cavalry",
        "8 CAV"
      ]
    },
    {
      "aliases": [
        "8PSY",
        "8th Psychological Operations Group (Airborne)"
      ],
      "label": "8th Psychological Operations Group (Airborne)",
      "tag": "AAC_UNIT_8PSY"
    },
    {
      "aliases": [
        "8SFG",
        "8th Special Forces Group (Airborne)",
        "8 SFG",
        "8th SFG",
        "8 Special Forces"
      ],
      "label": "8th Special Forces Group (Airborne)",
      "tag": "AAC_UNIT_8SFG"
    },
    {
      "aliases": [
        "9POB",
        "9th Psychological Operations Battalion (Airborne)"
      ],
      "label": "9th Psychological Operations Battalion (Airborne)",
      "tag": "AAC_UNIT_9POB"
    },
    {
      "aliases": [
        "373468AR",
        "Airborne Armor Legacy"
      ],
      "label": "Airborne Armor Legacy",
      "tag": "AAC_UNIT_373468AR"
    },
    {
      "aliases": [
        "34ADA-D",
        "Battery D, 3rd Battalion, 4th Air Defense Artillery Regiment"
      ],
      "label": "Battery D, 3rd Battalion, 4th Air Defense Artillery Regiment",
      "tag": "AAC_UNIT_34ADA-D"
    },
    {
      "aliases": [
        "307MED-A",
        "Company A, 307th Medical Battalion"
      ],
      "label": "Company A, 307th Medical Battalion",
      "tag": "AAC_UNIT_307MED-A"
    },
    {
      "aliases": [
        "2325INF-B",
        "Company B, 2nd Battalion, 325th Airborne Infantry Regiment",
        "Bravo Company, 2/325 AIR",
        "Bravo Company, 2nd Battalion, 325th Airborne Infantry Regiment",
        "B Company, 2/325 AIR"
      ],
      "label": "Company B, 2nd Battalion, 325th Airborne Infantry Regiment",
      "tag": "AAC_UNIT_2325INF-B"
    },
    {
      "aliases": [
        "307MED-B",
        "Company B, 307th Medical Battalion"
      ],
      "label": "Company B, 307th Medical Battalion",
      "tag": "AAC_UNIT_307MED-B"
    },
    {
      "aliases": [
        "412CA-B",
        "Company B, 412th Civil Affairs Battalion"
      ],
      "label": "Company B, 412th Civil Affairs Battalion",
      "tag": "AAC_UNIT_412CA-B"
    },
    {
      "aliases": [
        "509INF-C",
        "Company C (Pathfinder), 509th Infantry",
        "C Company Pathfinders, 509th Infantry"
      ],
      "label": "Company C (Pathfinder), 509th Infantry",
      "tag": "AAC_UNIT_509INF-C"
    },
    {
      "aliases": [
        "2504INF-C",
        "Company C, 2nd Battalion, 504th Parachute Infantry Regiment"
      ],
      "label": "Company C, 2nd Battalion, 504th Parachute Infantry Regiment",
      "tag": "AAC_UNIT_2504INF-C"
    },
    {
      "aliases": [
        "412CA-D",
        "Company D, 412th Civil Affairs Battalion"
      ],
      "label": "Company D, 412th Civil Affairs Battalion",
      "tag": "AAC_UNIT_412CA-D"
    },
    {
      "aliases": [
        "52LRS-E",
        "Company E, 52nd Infantry Regiment (Long Range Surveillance)"
      ],
      "label": "Company E, 52nd Infantry Regiment (Long Range Surveillance)",
      "tag": "AAC_UNIT_52LRS-E"
    },
    {
      "aliases": [
        "9POB-E",
        "Company E, 9th Psychological Operations Battalion (Airborne)"
      ],
      "label": "Company E, 9th Psychological Operations Battalion (Airborne)",
      "tag": "AAC_UNIT_9POB-E"
    },
    {
      "aliases": [
        "425INF-F",
        "Company F, 425th Infantry Regiment"
      ],
      "label": "Company F, 425th Infantry Regiment",
      "tag": "AAC_UNIT_425INF-F"
    },
    {
      "tag": "AAC_UNIT_531DET",
      "label": "Detachment 531, Company C, 5th Psychological Operations Battalion",
      "aliases": [
        "531DET",
        "Detachment 531",
        "Det 531",
        "531 Detachment",
        "C Company 5th POB Detachment 531"
      ]
    },
    {
      "aliases": [
        "505INF-HHC",
        "Headquarters and Headquarters Company, 505th Parachute Infantry Regiment"
      ],
      "label": "Headquarters and Headquarters Company, 505th Parachute Infantry Regiment",
      "tag": "AAC_UNIT_505INF-HHC"
    },
    {
      "aliases": [
        "SOCAFRICA",
        "Special Operations Command Africa",
        "SOC-Africa",
        "Special Operations Command Africa (SOCAFRICA)"
      ],
      "label": "Special Operations Command Africa",
      "tag": "AAC_UNIT_SOCAFRICA"
    },
    {
      "aliases": [
        "117CAV-A",
        "Troop A, 1st Squadron, 17th Cavalry Regiment (Airborne)"
      ],
      "label": "Troop A, 1st Squadron, 17th Cavalry Regiment (Airborne)",
      "tag": "AAC_UNIT_117CAV-A"
    },
    {
      "aliases": [
        "117CAV-B",
        "Troop B, 1st Squadron, 17th Cavalry Regiment (Airborne)"
      ],
      "label": "Troop B, 1st Squadron, 17th Cavalry Regiment (Airborne)",
      "tag": "AAC_UNIT_117CAV-B"
    },
    {
      "aliases": [
        "117CAV-C",
        "Troop C, 1st Squadron, 17th Cavalry Regiment (Airborne)"
      ],
      "label": "Troop C, 1st Squadron, 17th Cavalry Regiment (Airborne)",
      "tag": "AAC_UNIT_117CAV-C"
    },
    {
      "aliases": [
        "18ABN",
        "XVIII Airborne Corps"
      ],
      "label": "XVIII Airborne Corps",
      "tag": "AAC_UNIT_18ABN"
    }
  ];

  const compact = (value) => String(value || '')
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/\b(a\.i\.r\.|airborne infantry regiment)\b/g, 'air')
    .replace(/[^a-z0-9]/g, '');

  const aliasIndex = new Map();
  const conflictingAliases = new Set();
  unitGroups.forEach((group) => {
    group.aliases.concat([group.tag, group.label]).forEach((alias) => {
      const key = compact(alias);
      if (!key || conflictingAliases.has(key)) return;
      const existing = aliasIndex.get(key);
      if (existing && existing.tag !== group.tag) {
        aliasIndex.delete(key);
        conflictingAliases.add(key);
        return;
      }
      aliasIndex.set(key, group);
    });
  });

  const resolve = (value) => aliasIndex.get(compact(value));
  const ambiguous = {
    '173': {
      query: 'tag:AAC_UNIT_173ABN OR tag:AAC_UNIT_173LSB OR tag:AAC_UNIT_173MICO',
      key: '173'
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest && event.target.closest('form[action*="/search"]');
    if (!form) return;

    const input = form.querySelector('input[name="q"]');
    if (!input) return;

    const original = input.value.trim().replace(/^["']|["']$/g, '');
    const unit = resolve(original);
    const choice = ambiguous[compact(original)];
    if (!unit && !choice) return;

    event.preventDefault();
    const params = new URLSearchParams(new FormData(form));
    params.set('q', unit ? 'tag:' + unit.tag : choice.query);
    params.set('type', 'product');
    params.set('aac_query', original);
    if (choice) params.set('aac_choices', choice.key);
    window.location.assign('/search?' + params.toString());
  }, true);

  const params = new URLSearchParams(window.location.search);
  const displayQuery = params.get('aac_query');
  if (!displayQuery) {
    window.AACUnitSearch = { resolve };
    return;
  }

  document.querySelectorAll('form[action*="/search"] input[name="q"]').forEach((input) => {
    input.value = displayQuery;
  });

  const unit = resolve(displayQuery);
  const choiceKey = params.get('aac_choices');
  const searchRoot = document.querySelector('.search-content .page-content');
  const searchForm = searchRoot && searchRoot.querySelector('form[role="search"]');

  if (choiceKey === '173' && searchForm && !searchRoot.querySelector('.aac-unit-search-context')) {
    const context = document.createElement('div');
    context.className = 'aac-unit-search-context aac-unit-search-context--choices';
    context.innerHTML =
      '<strong>“173” can refer to several unit families.</strong>' +
      '<span>Choose the organization you meant, or browse the combined results below.</span>' +
      '<div class="aac-unit-search-options">' +
        '<a class="btn btn--small" href="/search?q=tag%3AAAC_UNIT_173ABN&type=product&aac_query=173rd+Airborne+Brigade">173rd Airborne Brigade</a>' +
        '<a class="btn btn--small" href="/search?q=tag%3AAAC_UNIT_173LSB&type=product&aac_query=173rd+Light+Support+Battalion">173rd Light Support Battalion</a>' +
        '<a class="btn btn--small" href="/search?q=tag%3AAAC_UNIT_173MICO&type=product&aac_query=173rd+Military+Intelligence+Company">173rd Military Intelligence Company</a>' +
      '</div>';
    searchForm.insertAdjacentElement('afterend', context);
  } else if (unit && searchForm && !searchRoot.querySelector('.aac-unit-search-context')) {
    const context = document.createElement('div');
    context.className = 'aac-unit-search-context';
    context.innerHTML =
      '<strong>Showing the complete ' + unit.label + ' product family.</strong>' +
      '<span>Use <em>Specific Unit</em> to narrow by battalion, then refine by era, operation, or product type.</span>';
    searchForm.insertAdjacentElement('afterend', context);
  }

  window.AACUnitSearch = { resolve };
})();